
import styled, { css } from "styled-components";



export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  
  width:80vw;

  border:2px black solid;

  padding:8px;

  margin-top:25px;



`;


export const Header = styled.div`

    display:flex;
    align-items:center;
    justify-content:space-around;

    width:60vw;

    margin:auto;
    margin-bottom:4px;
    margin-top:4px;

`;


export const DivHeader = styled.div`

    display:flex;
    align-items:center;
    justify-content:center;
    
    flex-direction:column;

`;


export const SpanHeader = styled.h2`

    font-size:16px ;
    font-weight:bold;
    text-align:center;
`;

export const TituloDiv = styled.div`
   
`;


export const Titulo = styled.h2`
 font-size:22px ;
  
`;


export const Subtitulo = styled.h4`
 font-size:16px ;
`;




interface SectionProps {
    w?: string;
    column?: boolean;
}
export const Section = styled.div<SectionProps>`
    width:${({ w }) => w ? w : "80vw"} ;
   
    padding-left:16px;
    padding-right:16px;
    display:flex;
    align-items:center;
    justify-content:space-between;

    ${({ column }) => column ? css`flex-direction:column;` : ""}


    

`;
interface InputProps {
    inline?: boolean;
    width: string;
}
export const Input = styled.div<InputProps>`
    font-size:14px;
    width:  ${({ width }) => width};

    ${({ inline }) => inline ? css`
    display:flex;
    align-items:center;
    justify-content:space-around;
    /* width:100%; */
   
    `: css`
    display:flex;
    align-items:flex-start;
    justify-content:center;
    flex-direction:column;`}
    margin-top:8px;
`;

export const Value = styled.div`
font-size:18px;
margin-top:8px;

border:1px black solid;
width: 100%;

padding:2px;

text-align:center;

`;

export const TituloSection = styled.div`
    width:100%;
  margin-left:20px;

    font-size:16px;
    font-weight:bold;
`;


export const Tr = styled.div`
    font-size:16px;
    display:flex;
    align-items:center;
    justify-content:space-between;
    width:300px;
  
`;

interface TdProps {
    value?: boolean;
}
export const Td = styled.td<TdProps>`
    width:100%;
${({ value }) => value ? css`border:1px black solid;text-align:center;` : css`text-align:justify;`};

margin-right:8px;
    
`;

export const Td2 = styled.td<TdProps>`
    

${({ value }) => value ? css`
border:0.1px black solid;
padding-left:4px;
padding-right:4px;
text-align:center;
width:100%;

` : css`
    text-align:justify;
    width:100%;
`};


`;

